export const translations = {
  tr: {
    // Navigation
    nav: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      products: "Ürünlerimiz",
      services: "Hizmetlerimiz",
      contact: "İletişim",
      contactBtn: "İletişime Geç"
    },
    // Hero Section
    hero: {
      badge: "Türkiye'nin Önde Gelen Glukonik Asit Üreticisi",
      companyName: "Meskim",
      companyFull: "Gıda İthalat İhracat Sanayi ve Ticaret Limited Şirketi",
      tagline: "Gıda ve Kimya Sektöründe Güvenilir Çözüm Ortağınız",
      description: "Türkiye'nin ilk ve tek glukonik asit ve glukono delta lakton üreticisi olarak, gıda ve kimya sektörlerine yüksek kaliteli ürünler sunuyoruz.",
      exploreProducts: "Ürünlerimizi Keşfedin",
      contactUs: "İletişime Geçin"
    },
    // About Section
    about: {
      title: "Hakkımızda",
      description: "Türkiye'nin ilk ve tek glukonik asit ve glukono delta lakton üreticisi olarak, kimya ve gıda sektörlerinde kaliteli üretim ve güvenilir hizmet anlayışıyla faaliyetlerimizi sürdürüyoruz.",
      stats: {
        experience: "Yıllık Deneyim",
        capacity: "Üretim Kapasitesi (ton/yıl)",
        satisfaction: "Müşteri Memnuniyeti",
        countries: "İhracat Ülkesi"
      },
      contentTitle: "Kalite ve Güven Odaklı Üretim",
      content1: "Modern tesislerimizde, uluslararası standartlara uygun olarak glukonik asit ve türevlerinin üretimini gerçekleştiriyoruz. Deneyimli ekibimiz ve ileri teknoloji ekipmanlarımızla, müşterilerimize en yüksek kalitede ürünler sunuyoruz.",
      content2: "Sürekli gelişim ve yenilikçilik ilkesiyle, Ar-Ge çalışmalarımıza büyük önem veriyor, sektördeki değişimleri yakından takip ederek müşterilerimize en iyi çözümleri sunmayı hedefliyoruz.",
      content3: "Çevre dostu üretim anlayışımız ve sürdürülebilirlik politikalarımızla, gelecek nesillere daha yaşanabilir bir dünya bırakmak için çalışıyoruz.",
      certificationsTitle: "Sertifikalarımız ve Standartlarımız",
      certificationsDesc: "Tüm üretim süreçlerimiz, uluslararası kalite ve güvenlik standartlarına uygun olarak sertifikalandırılmıştır. Müşterilerimize en yüksek kalitede ürün ve hizmet sunmak için sürekli olarak kendimizi geliştiriyoruz."
    },
    // Products Section
    products: {
      title: "Ürünlerimiz",
      description: "Yüksek kalitede kimyasal ürünlerimiz, gıda, ilaç ve inşaat sektörlerinde geniş bir kullanım alanına sahiptir.",
      viewDetails: "Detaylı Bilgi",
      backToProducts: "Ürünlere Dön",
      technicalSpecs: "Teknik Özellikler",
      packaging: "Ambalaj Seçenekleri",
      productionBadge: "Yerli Üretim",
      firstProducer: "Türkiye'nin İlk ve Tek Üreticisi",
      nationalTech: "Yerli ve Milli Teknoloji ile Üretim",
      packagingTypes: {
        ibcTank: "1000 Litrelik IBC Tank",
        barrel: "30 kg'lık Bidon",
        kraftBag: "25 kg'lık Kraft Torba"
      },
      product1: {
        name: "Glukonik Asit %50",
        description: "Sıvı formda %50 konsantrasyonunda glukonik asit üretimi yapıyoruz. Gıda, ilaç ve endüstriyel uygulamalarda yaygın olarak kullanılan yüksek saflıkta ürün.",
        spec: "Sıvı Form - %50 Konsantrasyon",
        apps: ["Gıda katkı maddesi", "pH düzenleyici", "İlaç sanayii", "Metal yüzey temizliği", "Beton katkı maddesi"]
      },
      product2: {
        name: "Glukonat Tuzları",
        description: "Çeşitli glukonat tuzları üretimi: Sodyum Glukonat, Potasyum Glukonat, Kalsiyum Glukonat ve Bakır Glukonat. Her biri farklı endüstriyel ve farmasötik uygulamalar için özel olarak üretilmektedir.",
        spec: "Toz Form - Çeşitli Saflık Dereceleri",
        apps: ["Sodyum Glukonat - Beton katkı", "Potasyum Glukonat - Gıda takviyesi", "Kalsiyum Glukonat - İlaç üretimi", "Bakır Glukonat - Mineral takviye", "Su arıtma sistemleri"]
      },
      product3: {
        name: "Glukono Delta Lakton (GDL)",
        description: "Glukono Delta Lakton, gıda endüstrisinde asitlik düzenleyici ve pıhtılaştırıcı olarak kullanılan yüksek kaliteli kimyasal üründür. Özellikle süt ürünleri ve et ürünleri işlemede tercih edilir.",
        spec: "Toz Form - Yüksek Saflık",
        apps: ["Peynir üretimi", "Et ürünleri işleme", "Fırıncılık ürünleri", "Asitlik düzenleyici", "Tofu üretimi"]
      },
      usageAreas: "Kullanım Alanları:",
      faqTitle: "Sıkça Sorulan Sorular",
      faq1Q: "Ürünlerinizin kalite standartları nelerdir?",
      faq1A: "Tüm ürünlerimiz ISO 9001:2015, ISO 22000, HACCP ve GMP standartlarına uygun olarak üretilmektedir. Her parti ürün, sevkiyat öncesi titiz kalite kontrol süreçlerinden geçmektedir.",
      faq2Q: "Minimum sipariş miktarı var mı?",
      faq2A: "Minimum sipariş miktarları ürüne göre değişiklik göstermektedir. Detaylı bilgi için lütfen bizimle iletişime geçin.",
      faq3Q: "Ürün numunesi alabilir miyim?",
      faq3A: "Evet, potansiyel müşterilerimize ürün numuneleri gönderebiliyoruz. Numune talepleriniz için lütfen iletişim formunu doldurun.",
      faq4Q: "Teslimat süresi ne kadardır?",
      faq4A: "Stokta bulunan ürünler için teslimat süresi ortalama 3-5 iş günüdür. Siparişe özel üretimler için teslimat süresi değişiklik gösterebilir."
    },
    // Services Section
    services: {
      title: "Hizmetlerimiz",
      description: "Müşterilerimize üretimden teslimatına kadar kapsamlı hizmet sunuyoruz.",
      service1: {
        title: "Üretim ve İmalat",
        description: "Modern tesislerimizde uluslararası standartlarda üretim yapıyoruz."
      },
      service2: {
        title: "Kalite Kontrol",
        description: "Her üretim aşamasında titiz kalite kontrol süreçleri uyguluyoruz."
      },
      service3: {
        title: "Lojistik ve Dağıtım",
        description: "Türkiye ve dünya genelinde güvenli ve hızlı teslimat hizmeti."
      },
      service4: {
        title: "Teknik Destek",
        description: "Uzman ekibimizle 7/24 teknik destek ve danışmanlık hizmeti sunuyoruz."
      },
      whyUs: "Neden Meskim?",
      whyUsDesc: "25 yılı aşkın sektör deneyimimiz, modern üretim tesislerimiz ve müşteri odaklı hizmet anlayışımızla sektörde fark yaratıyoruz.",
      quality: "Kalite Garantisi",
      support: "Müşteri Desteği",
      exportCountries: "İhracat Ülkesi",
      capacity: "Ton/Yıl Kapasite"
    },
    // Contact Section
    contact: {
      title: "İletişim",
      description: "Sorularınız, talepleriniz veya işbirliği teklifleriniz için bizimle iletişime geçin.",
      address: "Adres",
      phone: "Telefon",
      email: "E-posta",
      workingHours: "Çalışma Saatleri",
      formTitle: "Bize Ulaşın",
      namePlaceholder: "Adınız ve soyadınız",
      emailPlaceholder: "ornek@email.com",
      phonePlaceholder: "+90 5XX XXX XX XX",
      companyPlaceholder: "Şirket adınız",
      messagePlaceholder: "Mesajınızı buraya yazın...",
      name: "Ad Soyad",
      company: "Şirket",
      message: "Mesaj",
      send: "Mesaj Gönder",
      sending: "Gönderiliyor...",
      success: "Mesajınız alındı!",
      successDesc: "En kısa sürede sizinle iletişime geçeceğiz.",
      required: "*"
    },
    // Footer
    footer: {
      quickLinks: "Hızlı Bağlantılar",
      contactInfo: "İletişim Bilgileri",
      rights: "Tüm hakları saklıdır.",
      workingHoursValue: "Pazartesi - Cuma: 08:00 - 18:00"
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About Us",
      products: "Our Products",
      services: "Our Services",
      contact: "Contact",
      contactBtn: "Get in Touch"
    },
    // Hero Section
    hero: {
      badge: "Leading Gluconic Acid Producer in Turkey",
      companyName: "Meskim",
      companyFull: "Food Import Export Industry and Trade Limited Company",
      tagline: "Your Trusted Solution Partner in Food and Chemical Industry",
      description: "As Turkey's first and only gluconic acid and glucono delta lactone producer, we provide high-quality products to the food and chemical sectors.",
      exploreProducts: "Explore Our Products",
      contactUs: "Contact Us"
    },
    // About Section
    about: {
      title: "About Us",
      description: "As Turkey's first and only gluconic acid and glucono delta lactone producer, we continue our operations in the chemistry and food sectors with quality production and reliable service approach.",
      stats: {
        experience: "Years of Experience",
        capacity: "Production Capacity (ton/year)",
        satisfaction: "Customer Satisfaction",
        countries: "Export Countries"
      },
      contentTitle: "Quality and Trust-Focused Production",
      content1: "In our modern facilities, we produce gluconic acid and its derivatives in accordance with international standards. With our experienced team and advanced technology equipment, we provide our customers with the highest quality products.",
      content2: "With the principle of continuous improvement and innovation, we attach great importance to our R&D studies, closely following the changes in the sector and aiming to provide the best solutions to our customers.",
      content3: "With our environmentally friendly production approach and sustainability policies, we work to leave a more livable world for future generations.",
      certificationsTitle: "Our Certifications and Standards",
      certificationsDesc: "All our production processes are certified in accordance with international quality and safety standards. We continuously improve ourselves to provide our customers with the highest quality products and services."
    },
    // Products Section
    products: {
      title: "Our Products",
      description: "Our high-quality chemical products have a wide range of applications in the food, pharmaceutical, and construction industries.",
      viewDetails: "View Details",
      backToProducts: "Back to Products",
      technicalSpecs: "Technical Specifications",
      packaging: "Packaging Options",
      productionBadge: "Domestic Production",
      firstProducer: "Turkey's First and Only Producer",
      nationalTech: "Production with National and Indigenous Technology",
      packagingTypes: {
        ibcTank: "1000 Liter IBC Tank",
        barrel: "30 kg Barrel",
        kraftBag: "25 kg Kraft Bag"
      },
      product1: {
        name: "Gluconic Acid 50%",
        description: "We produce gluconic acid in liquid form at 50% concentration. High-purity product widely used in food, pharmaceutical, and industrial applications.",
        spec: "Liquid Form - 50% Concentration",
        apps: ["Food additive", "pH regulator", "Pharmaceutical industry", "Metal surface cleaning", "Concrete additive"]
      },
      product2: {
        name: "Gluconate Salts",
        description: "Production of various gluconate salts: Sodium Gluconate, Potassium Gluconate, Calcium Gluconate, and Copper Gluconate. Each is specially produced for different industrial and pharmaceutical applications.",
        spec: "Powder Form - Various Purity Grades",
        apps: ["Sodium Gluconate - Concrete additive", "Potassium Gluconate - Dietary supplement", "Calcium Gluconate - Pharmaceutical production", "Copper Gluconate - Mineral supplement", "Water treatment systems"]
      },
      product3: {
        name: "Glucono Delta Lactone (GDL)",
        description: "Glucono Delta Lactone is a high-quality chemical product used as an acidity regulator and coagulant in the food industry. It is particularly preferred in dairy and meat product processing.",
        spec: "Powder Form - High Purity",
        apps: ["Cheese production", "Meat products processing", "Bakery products", "Acidity regulator", "Tofu production"]
      },
      usageAreas: "Application Areas:",
      faqTitle: "Frequently Asked Questions",
      faq1Q: "What are the quality standards of your products?",
      faq1A: "All our products are manufactured in accordance with ISO 9001:2015, ISO 22000, HACCP, and GMP standards. Each batch of products undergoes rigorous quality control processes before shipment.",
      faq2Q: "Is there a minimum order quantity?",
      faq2A: "Minimum order quantities vary by product. Please contact us for detailed information.",
      faq3Q: "Can I get product samples?",
      faq3A: "Yes, we can send product samples to potential customers. Please fill out the contact form for your sample requests.",
      faq4Q: "What is the delivery time?",
      faq4A: "The average delivery time for products in stock is 3-5 business days. Delivery time may vary for custom production orders."
    },
    // Services Section
    services: {
      title: "Our Services",
      description: "We provide comprehensive services to our customers from production to delivery.",
      service1: {
        title: "Production and Manufacturing",
        description: "We produce according to international standards in our modern facilities."
      },
      service2: {
        title: "Quality Control",
        description: "We apply rigorous quality control processes at every production stage."
      },
      service3: {
        title: "Logistics and Distribution",
        description: "Safe and fast delivery service throughout Turkey and worldwide."
      },
      service4: {
        title: "Technical Support",
        description: "We provide 24/7 technical support and consultancy services with our expert team."
      },
      whyUs: "Why Meskim?",
      whyUsDesc: "With over 25 years of industry experience, our modern production facilities, and customer-focused service approach, we make a difference in the sector.",
      quality: "Quality Guarantee",
      support: "Customer Support",
      exportCountries: "Export Countries",
      capacity: "Ton/Year Capacity"
    },
    // Contact Section
    contact: {
      title: "Contact",
      description: "Contact us for your questions, requests, or cooperation proposals.",
      address: "Address",
      phone: "Phone",
      email: "Email",
      workingHours: "Working Hours",
      formTitle: "Contact Us",
      namePlaceholder: "Your full name",
      emailPlaceholder: "example@email.com",
      phonePlaceholder: "+90 5XX XXX XX XX",
      companyPlaceholder: "Your company name",
      messagePlaceholder: "Write your message here...",
      name: "Full Name",
      company: "Company",
      message: "Message",
      send: "Send Message",
      sending: "Sending...",
      success: "Message received!",
      successDesc: "We will contact you as soon as possible.",
      required: "*"
    },
    // Footer
    footer: {
      quickLinks: "Quick Links",
      contactInfo: "Contact Information",
      rights: "All rights reserved.",
      workingHoursValue: "Monday - Friday: 08:00 - 18:00"
    }
  },
  ru: {
    // Navigation
    nav: {
      home: "Главная",
      about: "О нас",
      products: "Наши продукты",
      services: "Наши услуги",
      contact: "Контакты",
      contactBtn: "Связаться"
    },
    // Hero Section
    hero: {
      badge: "Ведущий производитель глюконовой кислоты в Турции",
      companyName: "Meskim",
      companyFull: "Компания по импорту, экспорту продуктов питания, промышленности и торговле",
      tagline: "Ваш надежный партнер в пищевой и химической промышленности",
      description: "Как первый и единственный производитель глюконовой кислоты и глюконо-дельта-лактона в Турции, мы предоставляем высококачественные продукты для пищевой и химической промышленности.",
      exploreProducts: "Наши продукты",
      contactUs: "Связаться с нами"
    },
    // About Section
    about: {
      title: "О нас",
      description: "Как первый и единственный производитель глюконовой кислоты и глюконо-дельта-лактона в Турции, мы продолжаем свою деятельность в химической и пищевой промышленности с качественным производством и надежным подходом к обслуживанию.",
      stats: {
        experience: "Лет опыта",
        capacity: "Производственная мощность (тонн/год)",
        satisfaction: "Удовлетворенность клиентов",
        countries: "Страны экспорта"
      },
      contentTitle: "Производство, ориентированное на качество и доверие",
      content1: "На наших современных предприятиях мы производим глюконовую кислоту и ее производные в соответствии с международными стандартами. С нашей опытной командой и передовым технологическим оборудованием мы предоставляем нашим клиентам продукцию высочайшего качества.",
      content2: "Следуя принципу постоянного совершенствования и инноваций, мы придаем большое значение нашим исследованиям и разработкам, внимательно следя за изменениями в отрасли и стремясь предоставить нашим клиентам лучшие решения.",
      content3: "С нашим экологически чистым подходом к производству и политикой устойчивого развития мы работаем над тем, чтобы оставить будущим поколениям более пригодный для жизни мир.",
      certificationsTitle: "Наши сертификаты и стандарты",
      certificationsDesc: "Все наши производственные процессы сертифицированы в соответствии с международными стандартами качества и безопасности. Мы постоянно совершенствуемся, чтобы предоставлять нашим клиентам продукты и услуги высочайшего качества."
    },
    // Products Section
    products: {
      title: "Наши продукты",
      description: "Наши высококачественные химические продукты имеют широкий спектр применения в пищевой, фармацевтической и строительной промышленности.",
      viewDetails: "Подробнее",
      backToProducts: "Вернуться к продуктам",
      technicalSpecs: "Технические характеристики",
      packaging: "Варианты упаковки",
      productionBadge: "Отечественное производство",
      firstProducer: "Первый и единственный производитель в Турции",
      nationalTech: "Производство с национальными и местными технологиями",
      packagingTypes: {
        ibcTank: "IBC-емкость 1000 литров",
        barrel: "Бочка 30 кг",
        kraftBag: "Крафт-мешок 25 кг"
      },
      product1: {
        name: "Глюконовая кислота 50%",
        description: "Мы производим глюконовую кислоту в жидкой форме с концентрацией 50%. Высокочистый продукт, широко используемый в пищевой, фармацевтической и промышленной сферах.",
        spec: "Жидкая форма - концентрация 50%",
        apps: ["Пищевая добавка", "Регулятор pH", "Фармацевтическая промышленность", "Очистка металлических поверхностей", "Добавка для бетона"]
      },
      product2: {
        name: "Глюконатные соли",
        description: "Производство различных глюконатных солей: глюконат натрия, глюконат калия, глюконат кальция и глюконат меди. Каждый специально производится для различных промышленных и фармацевтических применений.",
        spec: "Порошковая форма - различные степени чистоты",
        apps: ["Глюконат натрия - добавка для бетона", "Глюконат калия - пищевая добавка", "Глюконат кальция - фармацевтическое производство", "Глюконат меди - минеральная добавка", "Системы водоочистки"]
      },
      product3: {
        name: "Глюконо-дельта-лактон (GDL)",
        description: "Глюконо-дельта-лактон - это высококачественный химический продукт, используемый в качестве регулятора кислотности и коагулянта в пищевой промышленности. Особенно предпочтителен при переработке молочных и мясных продуктов.",
        spec: "Порошковая форма - высокая чистота",
        apps: ["Производство сыра", "Переработка мясных продуктов", "Хлебобулочные изделия", "Регулятор кислотности", "Производство тофу"]
      },
      usageAreas: "Области применения:",
      faqTitle: "Часто задаваемые вопросы",
      faq1Q: "Каковы стандарты качества ваших продуктов?",
      faq1A: "Все наши продукты производятся в соответствии со стандартами ISO 9001:2015, ISO 22000, HACCP и GMP. Каждая партия продукции проходит строгий контроль качества перед отправкой.",
      faq2Q: "Существует ли минимальное количество заказа?",
      faq2A: "Минимальные количества заказа варьируются в зависимости от продукта. Пожалуйста, свяжитесь с нами для получения подробной информации.",
      faq3Q: "Могу ли я получить образцы продукции?",
      faq3A: "Да, мы можем отправить образцы продукции потенциальным клиентам. Пожалуйста, заполните контактную форму для запроса образцов.",
      faq4Q: "Каков срок доставки?",
      faq4A: "Средний срок доставки продукции, имеющейся на складе, составляет 3-5 рабочих дней. Для индивидуальных заказов срок доставки может варьироваться."
    },
    // Services Section
    services: {
      title: "Наши услуги",
      description: "Мы предоставляем нашим клиентам комплексные услуги от производства до доставки.",
      service1: {
        title: "Производство и изготовление",
        description: "Мы производим в соответствии с международными стандартами на наших современных предприятиях."
      },
      service2: {
        title: "Контроль качества",
        description: "Мы применяем строгие процессы контроля качества на каждом этапе производства."
      },
      service3: {
        title: "Логистика и распределение",
        description: "Безопасная и быстрая доставка по всей Турции и по всему миру."
      },
      service4: {
        title: "Техническая поддержка",
        description: "Мы предоставляем круглосуточную техническую поддержку и консультационные услуги с нашей экспертной командой."
      },
      whyUs: "Почему Meskim?",
      whyUsDesc: "С более чем 25-летним опытом работы в отрасли, нашими современными производственными мощностями и клиентоориентированным подходом к обслуживанию мы делаем разницу в отрасли.",
      quality: "Гарантия качества",
      support: "Поддержка клиентов",
      exportCountries: "Страны экспорта",
      capacity: "Тонн/год мощность"
    },
    // Contact Section
    contact: {
      title: "Контакты",
      description: "Свяжитесь с нами по вашим вопросам, запросам или предложениям о сотрудничестве.",
      address: "Адрес",
      phone: "Телефон",
      email: "Электронная почта",
      workingHours: "Часы работы",
      formTitle: "Свяжитесь с нами",
      namePlaceholder: "Ваше полное имя",
      emailPlaceholder: "primer@email.com",
      phonePlaceholder: "+90 5XX XXX XX XX",
      companyPlaceholder: "Название вашей компании",
      messagePlaceholder: "Напишите ваше сообщение здесь...",
      name: "Полное имя",
      company: "Компания",
      message: "Сообщение",
      send: "Отправить сообщение",
      sending: "Отправка...",
      success: "Сообщение получено!",
      successDesc: "Мы свяжемся с вами в ближайшее время.",
      required: "*"
    },
    // Footer
    footer: {
      quickLinks: "Быстрые ссылки",
      contactInfo: "Контактная информация",
      rights: "Все права защищены.",
      workingHoursValue: "Понедельник - Пятница: 08:00 - 18:00"
    }
  },
  ar: {
    // Navigation
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      products: "منتجاتنا",
      services: "خدماتنا",
      contact: "اتصل بنا",
      contactBtn: "تواصل معنا"
    },
    // Hero Section
    hero: {
      badge: "الشركة الرائدة في إنتاج حمض الجلوكونيك في تركيا",
      companyName: "ميسكيم",
      companyFull: "شركة استيراد وتصدير الأغذية والصناعة والتجارة المحدودة",
      tagline: "شريكك الموثوق في صناعة الأغذية والكيماويات",
      description: "كأول وأكبر منتج لحمض الجلوكونيك وجلوكونو دلتا لاكتون في تركيا، نقدم منتجات عالية الجودة لقطاعات الأغذية والكيماويات.",
      exploreProducts: "اكتشف منتجاتنا",
      contactUs: "اتصل بنا"
    },
    // About Section
    about: {
      title: "من نحن",
      description: "كأول وأكبر منتج لحمض الجلوكونيك وجلوكونو دلتا لاكتون في تركيا، نواصل عملياتنا في قطاعي الكيماويات والأغذية مع الإنتاج الجيد ونهج الخدمة الموثوقة.",
      stats: {
        experience: "سنوات الخبرة",
        capacity: "الطاقة الإنتاجية (طن/سنة)",
        satisfaction: "رضا العملاء",
        countries: "دول التصدير"
      },
      contentTitle: "إنتاج يركز على الجودة والثقة",
      content1: "في منشآتنا الحديثة، ننتج حمض الجلوكونيك ومشتقاته وفقًا للمعايير الدولية. مع فريقنا ذو الخبرة ومعداتنا التكنولوجية المتقدمة، نقدم لعملائنا منتجات بأعلى جودة.",
      content2: "مع مبدأ التحسين المستمر والابتكار، نولي أهمية كبيرة لدراسات البحث والتطوير لدينا، ونتابع عن كثب التغييرات في القطاع ونهدف إلى تقديم أفضل الحلول لعملائنا.",
      content3: "مع نهجنا في الإنتاج الصديق للبيئة وسياسات الاستدامة، نعمل على ترك عالم أكثر صلاحية للعيش للأجيال القادمة.",
      certificationsTitle: "شهاداتنا ومعاييرنا",
      certificationsDesc: "جميع عمليات الإنتاج لدينا معتمدة وفقًا لمعايير الجودة والسلامة الدولية. نحن نحسن أنفسنا باستمرار لتقديم منتجات وخدمات بأعلى جودة لعملائنا."
    },
    // Products Section
    products: {
      title: "منتجاتنا",
      description: "منتجاتنا الكيميائية عالية الجودة لها مجموعة واسعة من التطبيقات في صناعات الأغذية والأدوية والبناء.",
      viewDetails: "عرض التفاصيل",
      backToProducts: "العودة إلى المنتجات",
      technicalSpecs: "المواصفات الفنية",
      packaging: "خيارات التعبئة",
      productionBadge: "إنتاج محلي",
      firstProducer: "أول وأكبر منتج في تركيا",
      nationalTech: "الإنتاج بالتكنولوجيا الوطنية والمحلية",
      packagingTypes: {
        ibcTank: "خزان IBC سعة 1000 لتر",
        barrel: "برميل 30 كجم",
        kraftBag: "كيس كرافت 25 كجم"
      },
      product1: {
        name: "حمض الجلوكونيك 50%",
        description: "ننتج حمض الجلوكونيك في شكل سائل بتركيز 50%. منتج عالي النقاء يستخدم على نطاق واسع في تطبيقات الأغذية والأدوية والصناعية.",
        spec: "شكل سائل - تركيز 50%",
        apps: ["مضاف غذائي", "منظم الحموضة", "صناعة الأدوية", "تنظيف الأسطح المعدنية", "مضاف للخرسانة"]
      },
      product2: {
        name: "أملاح الجلوكونات",
        description: "إنتاج أملاح جلوكونات مختلفة: جلوكونات الصوديوم، جلوكونات البوتاسيوم، جلوكونات الكالسيوم، وجلوكونات النحاس. يتم إنتاج كل منها خصيصًا لتطبيقات صناعية ودوائية مختلفة.",
        spec: "شكل مسحوق - درجات نقاء مختلفة",
        apps: ["جلوكونات الصوديوم - مضاف للخرسانة", "جلوكونات البوتاسيوم - مكمل غذائي", "جلوكونات الكالسيوم - إنتاج الأدوية", "جلوكونات النحاس - مكمل معدني", "أنظمة معالجة المياه"]
      },
      product3: {
        name: "جلوكونو دلتا لاكتون (GDL)",
        description: "جلوكونو دلتا لاكتون هو منتج كيميائي عالي الجودة يستخدم كمنظم للحموضة ومخثر في صناعة الأغذية. يفضل بشكل خاص في معالجة منتجات الألبان واللحوم.",
        spec: "شكل مسحوق - نقاء عالي",
        apps: ["إنتاج الجبن", "معالجة منتجات اللحوم", "منتجات المخابز", "منظم الحموضة", "إنتاج التوفو"]
      },
      usageAreas: "مجالات الاستخدام:",
      faqTitle: "الأسئلة الشائعة",
      faq1Q: "ما هي معايير الجودة لمنتجاتكم؟",
      faq1A: "يتم تصنيع جميع منتجاتنا وفقًا لمعايير ISO 9001:2015 و ISO 22000 و HACCP و GMP. تخضع كل دفعة من المنتجات لعمليات مراقبة جودة صارمة قبل الشحن.",
      faq2Q: "هل هناك حد أدنى لكمية الطلب؟",
      faq2A: "تختلف الكميات الدنيا للطلب حسب المنتج. يرجى الاتصال بنا للحصول على معلومات مفصلة.",
      faq3Q: "هل يمكنني الحصول على عينات من المنتجات؟",
      faq3A: "نعم، يمكننا إرسال عينات من المنتجات للعملاء المحتملين. يرجى ملء نموذج الاتصال لطلبات العينات الخاصة بك.",
      faq4Q: "ما هو وقت التسليم؟",
      faq4A: "متوسط ​​وقت التسليم للمنتجات المتوفرة في المخزون هو 3-5 أيام عمل. قد يختلف وقت التسليم للطلبات المخصصة."
    },
    // Services Section
    services: {
      title: "خدماتنا",
      description: "نقدم لعملائنا خدمات شاملة من الإنتاج إلى التسليم.",
      service1: {
        title: "الإنتاج والتصنيع",
        description: "ننتج وفقًا للمعايير الدولية في منشآتنا الحديثة."
      },
      service2: {
        title: "مراقبة الجودة",
        description: "نطبق عمليات مراقبة جودة صارمة في كل مرحلة من مراحل الإنتاج."
      },
      service3: {
        title: "اللوجستيات والتوزيع",
        description: "خدمة توصيل آمنة وسريعة في جميع أنحاء تركيا وحول العالم."
      },
      service4: {
        title: "الدعم الفني",
        description: "نقدم دعمًا فنيًا وخدمات استشارية على مدار الساعة طوال أيام الأسبوع مع فريق الخبراء لدينا."
      },
      whyUs: "لماذا ميسكيم؟",
      whyUsDesc: "مع أكثر من 25 عامًا من الخبرة في الصناعة، ومنشآتنا الإنتاجية الحديثة، ونهجنا في الخدمة الموجهة نحو العملاء، نحدث فرقًا في القطاع.",
      quality: "ضمان الجودة",
      support: "دعم العملاء",
      exportCountries: "دول التصدير",
      capacity: "طن/سنة السعة"
    },
    // Contact Section
    contact: {
      title: "اتصل بنا",
      description: "اتصل بنا لأسئلتك أو طلباتك أو مقترحات التعاون.",
      address: "العنوان",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      workingHours: "ساعات العمل",
      formTitle: "تواصل معنا",
      namePlaceholder: "اسمك الكامل",
      emailPlaceholder: "example@email.com",
      phonePlaceholder: "+90 5XX XXX XX XX",
      companyPlaceholder: "اسم شركتك",
      messagePlaceholder: "اكتب رسالتك هنا...",
      name: "الاسم الكامل",
      company: "الشركة",
      message: "الرسالة",
      send: "إرسال الرسالة",
      sending: "جاري الإرسال...",
      success: "تم استلام الرسالة!",
      successDesc: "سنتواصل معك في أقرب وقت ممكن.",
      required: "*"
    },
    // Footer
    footer: {
      quickLinks: "روابط سريعة",
      contactInfo: "معلومات الاتصال",
      rights: "جميع الحقوق محفوظة.",
      workingHoursValue: "الاثنين - الجمعة: 08:00 - 18:00"
    }
  }
};
